/*
 * @Author: 陈朝晖
 * @Date: 2023-09-25 14:42:13
 * @LastEditTime: 2023-09-25 15:15:43
 * @Description:
 */

import prototypes from '../plugins/prototypes';
import filters from '../plugins/filters/index';
import directives from '../plugins/directives';
export default {
    prototypes,
    filters,
    directives,
};
